"use strict";
exports.__esModule = true;
exports.chart_legend_position = {
  "name": "--pf-chart-legend--position",
  "value": "right",
  "var": "var(--pf-chart-legend--position, right)"
};
exports["default"] = exports.chart_legend_position;